import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X, LogOut, User } from 'lucide-react';
import { navigationItems } from '../mockData';
 
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isBannerVisible, setIsBannerVisible] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Check if user is logged in
  const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
  const isLoggedIn = !!localStorage.getItem('token');

  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    setIsProfileOpen(false);
    navigate('/login');
  };

  // Get user initials for avatar
const getUserInitials = () => {
    if (currentUser?.name) {
      return currentUser.name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
    }
    if (currentUser?.email) {
      return currentUser.email[0].toUpperCase();
    }
    return 'W';
  };
 
  return (
    <>
{/* Notification Banner */}
{isBannerVisible && (
  <div className="fixed top-0 left-0 w-full z-[9999] animate-in slide-in-from-top-0 duration-500">
    <div className="relative w-full bg-gradient-to-r from-red-700 via-green-700 via-emerald-600 to-red-700 px-6 py-4">

      {/* CENTER CONTENT */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" >
        <div className="flex items-center gap-3 text-center">
          <div>
            <p className="text-white font-semibold text-sm md:text-base">
              New Update
            </p>
            <p className="text-white/90 text-xs md:text-sm">
              Good ideas take time so grace period added. Idea submission form closing soon.
            </p>
          </div>
        </div>
      </div>

      {/* RIGHT: Close Button */}
      <div className="flex justify-end">
        <button
          onClick={() => setIsBannerVisible(false)}
          className="p-1.5 hover:bg-white/20 rounded-lg transition-colors duration-200"
          aria-label="Close notification"
        >
          <X className="w-5 h-5 text-white" />
        </button>
      </div>

    </div>
  </div>
)}



      {/* Header */}
      <header className={`fixed left-0 w-full z-[999] bg-black/70 backdrop-blur-md border-b border-white/10 transition-all duration-300 ${
        isBannerVisible ? 'top-[55px]' : 'top-0'
      }`}>
        <div className="max-w-7xl mx-auto w-full px-6 py-3">
          <div className="flex items-center justify-between">
           
            {/* Left: Logo */}
            <Link
              to="/"
              className="flex items-center space-x-2 group flex-shrink-0"
            >
              <img
                src="/images/logo.png"
                alt="logotype"
                className="h-10 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
              />
            </Link>
   
            {/* Center: Navigation */}
            <nav className="hidden lg:flex flex-1 justify-center items-center space-x-3 bg-black/50 px-5 py-2 rounded-2xl backdrop-blur-md mx-6">
              {navigationItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                    location.pathname === item.path
                      ? 'bg-white/20 text-white'
                      : 'text-white hover:bg-white/10'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </nav>
   
            {/* Right: CTA Button & Profile */}
            <div className="hidden lg:flex items-center gap-3 flex-shrink-0">
              {/* <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSekok3wYw-j3eSw0OGBB1amsopP7PzZ4H0NHkQ9WDcFLEPyfA/viewform"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button className="bg-red-600 hover:bg-red-700 text-white font-semibold">
                  Submit Use Case Idea
                </Button>
              </a> */}
              <a
                href="/submission-insights"
                rel="noopener noreferrer"
              >
                <Button className="bg-gradient-to-r from-red-600 to-green-600 hover:opacity-90 transition-all duration-300 text-white font-semibold">
                  Insights
                </Button>
              </a>
              {/* Profile Section */}
              {isLoggedIn && (
                <div className="relative">
                  <button
                    onClick={() => setIsProfileOpen(!isProfileOpen)}
                    className="w-[3.35rem] h-[3.35rem] rounded-full bg-gradient-to-br from-green-400 to-red-500 flex items-center justify-center text-white font-bold text-2xl leading-none hover:shadow-xl hover:scale-110 transition-all duration-200"
                  >
                    {getUserInitials()}
                  </button>

                  {/* Dropdown Menu */}
                  {isProfileOpen && (
                    <div className="absolute right-0 mt-2 w-56 bg-black/95 backdrop-blur-md border border-white/20 rounded-xl shadow-xl overflow-hidden animate-in slide-in-from-top-2">
                      <div className="px-4 py-3 border-b border-white/10">
                        <p className="text-sm font-medium text-white truncate">
                          {currentUser?.name || 'Welcome'}
                        </p>
                        <p className="text-xs text-gray-400 truncate">
                          {currentUser?.email}
                        </p>
                      </div>
                      <button
                        onClick={handleLogout}
                        className="w-full px-4 py-3 flex items-center gap-3 text-sm text-red-400 hover:bg-white/10 transition-colors duration-200"
                      >
                        <LogOut className="w-4 h-4" />
                        Logout
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
   
            {/* Mobile Menu Button */}
            <button
              className="lg:hidden p-2 rounded-lg hover:bg-white/10 transition-colors duration-200 z-[1000] relative"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? (
                <X className="w-6 h-6 text-white" />
              ) : (
                <Menu className="w-6 h-6 text-white" />
              )}
            </button>
          </div>
   
          {/* Mobile Navigation */}
          {isMenuOpen && (
            <nav className="lg:hidden mt-4 pb-4 border-t border-white/20 pt-4 bg-black/80 rounded-xl backdrop-blur-md animate-in slide-in-from-top-2">
              <div className="flex flex-col space-y-2">
                {navigationItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setIsMenuOpen(false)}
                    className={`px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 ${
                      location.pathname === item.path
                        ? 'bg-white/20 text-white'
                        : 'text-white hover:bg-white/10'
                    }`}
                  >
                    {item.name}
                  </Link>
                ))}
                <Link to={`/submit-idea${location.search}`} onClick={() => setIsMenuOpen(false)}>
                  <Button className="w-full bg-red-600 hover:bg-red-700 text-white mt-2">
                    Submit Use Case Idea
                  </Button>
                </Link>

                {/* Mobile Profile Section */}
                {isLoggedIn && (
                  <div className="mt-4 pt-4 border-t border-white/10">
                    <div className="px-4 py-2 mb-2">
                      <p className="text-sm font-medium text-white">
                        {currentUser?.name || 'Welcome'}
                      </p>
                      <p className="text-xs text-gray-400">
                        {currentUser?.email}
                      </p>
                    </div>
                    <button
                      onClick={() => {
                        handleLogout();
                        setIsMenuOpen(false);
                      }}
                      className="w-full px-4 py-3 flex items-center gap-3 text-sm text-red-400 hover:bg-white/10 rounded-lg transition-colors duration-200"
                    >
                      <LogOut className="w-4 h-4" />
                      Logout
                    </button>
                  </div>
                )}
              </div>
            </nav>
          )}
        </div>
      </header>
    </>
  );
};
 
export default Header;